import _ from '@/utils/lodash-optimized'
import { Component } from 'react'

import {
  MedicationAmounts as Amounts,
  MedicationFrequencies as Frequencies,
  MedicationRoutes as Routes,
  MedicationUnits as Units
} from '../../../../lib/Codes'
import {
  bindTargetMixin,
  CancelButton,
  CareTeamMemberSelectInput,
  CheckboxInput,
  DateInput,
  mapCodeForSelect,
  RxnormAutocompleteInput,
  SaveButton,
  SelectInput,
  TextInput
} from '../../../shared/FormBuilder'
import { Paper, RequiredSpan } from '../../../shared/NarusMaterial'

const MedicationStatuses = [
  {
    label: 'Active',
    code: 'active'
  },
  {
    label: 'Completed',
    code: 'completed'
  },
  {
    label: 'Entered-In-Error',
    code: 'entered-in-error'
  },
  {
    label: 'Intended',
    code: 'intended'
  },
  {
    label: 'Stopped',
    code: 'stopped'
  },
  {
    label: 'On-Hold',
    code: 'on-hold'
  }
]

const mapCodeForFrequenciesSelect = options =>
  options.map(o => ({
    ...o,
    label: (o.label).charAt(0).toUpperCase() + (o.label).slice(1),
    value: o.code || o.value
  }))

const style = {
  textField: {
    marginBottom: '1rem',
    width: '100%'
  },
  saveButton: {
    marginLeft: '1rem'
  },
  checkBox: {
    position: 'relative',
    top: '40px'
  }
}

class MedicationForm extends bindTargetMixin(Component) {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.getValue = this.getValue.bind(this)
    this.handleRxnormSelect = this.handleRxnormSelect.bind(this)
  }

  getValue () {
    return { ...this.state.value }
  }

  handleRxnormSelect (medication) {
    this.setState({
      value: {
        ...this.state.value,
        coding: medication
      }
    })
  }

  handleSubmit () {
    const { onSubmit } = this.props

    this.setState({ isSubmitting: true })
    onSubmit(this.getValue())
  }

  renderRequiredStopDate () {
    const { statuses } = this.props
    const state = this.getValue()
    const { status } = state
    if (statuses?.includes(status)) {
      return <RequiredSpan />
    }
    return null
  }

  render () {
    const { onCancel, statuses } = this.props

    const state = this.getValue()
    const { coding, sideEffects, sideEffectsDescribed, status, start, stop } =
      state
    const isSideEffectsDescribedRequired = sideEffects === 'yes'
    const disableSave =
        !coding?.code ||
      _.isEmpty(status) ||
      (isSideEffectsDescribedRequired && _.isEmpty(sideEffectsDescribed)) ||
      (status === 'active' && _.isEmpty(start)) ||
      (statuses?.includes(status) && _.isEmpty(stop))

    return (
      <Paper>
        <div className='row'>
          <div className='col-xs-12 col-sm-12 col-md-12'>
            <RxnormAutocompleteInput
              name='coding'
              tty='SCD,SBD'
              label='Medication Name'
              required
            />
          </div>

          <div className='col-xs-12 col-sm-6 col-md-2'>
            <SelectInput
              options={mapCodeForSelect(Amounts)}
              label='Amt'
              name='dose'
            />
          </div>

          <div className='col-xs-12 col-sm-6 col-md-3'>
            <SelectInput
              options={mapCodeForSelect(Units)}
              label='Unit'
              name='unit'
            />
          </div>

          <div className='col-xs-12 col-sm-6 col-md-7'>
            <SelectInput
              options={mapCodeForSelect(Routes)}
              label='Route'
              name='route'
              hintText='Route'
            />
          </div>
          <div className='col-xs-12 col-sm-6 col-md-2'>
            <SelectInput
              options={mapCodeForFrequenciesSelect(Frequencies)}
              label='Frequency'
              name='frequency'
            />
          </div>

          <div className='col-xs-12 col-sm-4 col-md-4'>
            <CareTeamMemberSelectInput
              name='prescriber'
              label='Prescriber'
              patientId={this.props.patientId}
            />
          </div>

          <div className='col-xs-12 col-sm-4 col-md-4'>
            <SelectInput
              name='status'
              options={mapCodeForSelect(MedicationStatuses)}
              label='Status'
            />
            <RequiredSpan />
          </div>

          <div className='col-xs-12 col-sm-6 col-md-2'>
            <CheckboxInput
              label='PRN'
              name='prn'
              style={style.checkBox}
            />
          </div>

          <div className='col-xs-12 col-sm-4 col-md-4'>
            <TextInput
              label='Indication'
              name='indication'
            />
          </div>

          <div className='col-xs-12 col-sm-6 col-md-4 mui-date-picker-extended'>
            <DateInput
              label='Start Date'
              name='start'
            />
            {status === 'active' ? <RequiredSpan /> : null}
          </div>

          <div className='col-xs-12 col-sm-6 col-md-4 mui-date-picker-extended'>
            <DateInput
              label='End Date'
              name='stop'
            />
            {this.renderRequiredStopDate()}
          </div>

          <div className='col-xs-12 col-sm-12 col-md-12'>
            <TextInput
              label='Comments'
              name='comments'
            />
          </div>
        </div>
        <div
          className='row'
          style={{ marginTop: 20 }}
        >
          <div
            className='col-xs-12 col-md-12'
            style={{ alignSelf: 'baseline' }}
          >
            <CheckboxInput
              label='Discussed with Patient'
              name='discussedWithPatient'
            />
          </div>
        </div>
        <div
          style={{
            marginTop: '20px',
            display: 'flex',
            padding: '0 14px',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          {coding?.code && (
            <span style={{ color: '#979797' }}>
              RxNorm Code: {coding.code}
            </span>
          )}

          <div>
            <CancelButton
              noGlobal
              onClick={onCancel}
            />
            <SaveButton
              disabled={this.state.isSubmitting || disableSave}
              onClick={this.handleSubmit}
            />
          </div>
        </div>
      </Paper>
    )
  }
}

export default MedicationForm
